import React from 'react'
import { Button, Tooltip } from '@intelie/ui'

import i18n from 'live/services/i18n'

import { ApprovalOverviewRelatedPagesButtonRegistry } from 'plugin-joblog/shared/lib/approval-overview-related-pages-button-registry'
import { canAccessPSR } from '../permissions/permissions'

const registerApprovalOverviewRelatedPagesButton = (fracEventAlias: string, postStageReportAlias: string) =>
    ApprovalOverviewRelatedPagesButtonRegistry.register({
        title: i18n('Post Stage Report'),
        Component: props => {
            if (!canAccessPSR()) return null

            const { type, eventUid, crewUID } = props.eventData
            const isStage = type === 'StageKPIs'

            return isStage ? (
                <Tooltip overlay={'Post stage report page'} placement="top">
                    <Button
                        style={{
                            display: 'flex',
                            width: '32px',
                            height: '32px',
                            padding: '10px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '10px',
                            backgroundColor: 'var(--gray-100)',
                            borderRadius: '4px'
                        }}
                        variant="text"
                        size="md"
                        onClick={() => {
                            const basePath = window.location.pathname
                            const hash = `/${fracEventAlias}/${postStageReportAlias}/${crewUID}/run/${eventUid}`

                            const url = `${basePath}#${hash}`

                            window.open(url, '_blank', 'noopener,noreferrer')
                        }}
                    >
                        <i
                            style={{
                                fontSize: '13px',
                                fontWeight: 400,
                                lineHeight: 'normal',
                                color: 'var(--gray-800)'
                            }}
                            className="far fa-file-alt"
                        />
                    </Button>
                </Tooltip>
            ) : null
        }
    })

export default registerApprovalOverviewRelatedPagesButton
